<div class="flex justify-between items-start">
  <div class="device-img-wrapper">
    <ng-container *ngIf="device.deviceImage || imageUri; else hideImage">
      <img data-at-img [src]="device.deviceImage || imageUri" class="device-img" />
    </ng-container>
    <ng-template #hideImage>
      <mat-icon class="hide-image">hide_image</mat-icon>
    </ng-template>
  </div>
  <div class="flex flex-col justify-center items-start">
    <ng-container *ngIf="isHeatpump; else otherDeviceTile">
      <div data-at-title class="device-name flex flex-row gap-[8px] justify-start items-center">
        {{ '+INSTALLATIONS.DRY_CONTACTS.HEAT_PUMP.HEADER' | translate }}
      </div>
    </ng-container>

    <ng-template #otherDeviceTile>
      <div
        *ngrxLet="deviceName$ as feature"
        class="device-name-container flex flex-row gap-[8px] justify-start items-center"
      >
        <div
          data-device-name
          class="device-name flex flex-row gap-[8px] justify-start items-center"
        >
          <span
            >{{feature?.properties?.name?.value ?? (('+INSTALLATIONS.DRY_CONTACTS.GENERIC_CONSUMER.OTHER_DEVICE' | translate) + ' ' + deviceNumber)}}</span
          >
          <img *ngIf="brandLogo" class="mt-[-2px]" src="{{ brandLogo }}" />
        </div>
      </div>
    </ng-template>
    <div class="sub-title-container">
      <ng-container *ngIf="isHeatpump; else dryContactSubtitle">
        <div class="subtitle" *ngIf="deviceName$ | async as feature">
          <span>{{ feature?.properties?.name?.value }}</span>
        </div>
      </ng-container>
      <ng-template #dryContactSubtitle>
        <div class="subtitle">
          {{ '+INSTALLATIONS.DRY_CONTACTS.GENERIC_CONSUMER.HEADER_SUBTITLE' | translate }}
        </div>
      </ng-template>
    </div>
  </div>
</div>
